module.exports = __webpack_public_path__ + "img/img24.1692b93a.svg";